import React from "react";
import styled from "styled-components";
import { text } from "@carvana/helios-styles";

import { showChat } from "@/utils/zendesk";
import { helpUrl } from "@/utils/constants";

import MaxContentWrapper from "../MaxContentWrapper";
import GrayLine from "../GrayLine";
import TrackedLink from "../TrackedLink";

const Footer = () => {
  return (
    <MaxContentWrapper>
      <GrayLine width="80%" />
      <InfoFooter>
        <MoreQuestions>More questions?</MoreQuestions>
        <LinksContainer>
          <FaqLink
            href={helpUrl}
            segmentProps={{
              event: "Help Clicked",
              props: { component: "Footer Learn More Button" },
            }}
          >
            Learn More
          </FaqLink>
          <span>or</span>
          <Contact role="button" tabIndex={-2} onClick={showChat}>
            Contact Us
          </Contact>
        </LinksContainer>
      </InfoFooter>
    </MaxContentWrapper>
  );
};

const MoreQuestions = styled.h5`
  margin: 0;
  color: ${text.strong};
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
`;

const InfoFooter = styled.div`
  text-align: center;
  padding: 40px 0 65px;
  & span {
    float: left;
    margin: 0 5px;
    font-size: 16px;
    line-height: 1;
  }
`;

const LinksContainer = styled.div`
  display: inline-block;
`;

const FaqLink = styled(TrackedLink)`
  float: left;
  color: ${text.primary};
  font-size: 16px;
  line-height: 1;
  &:hover {
    text-decoration: underline;
  }
`;

const Contact = styled.a`
  float: left;
  color: ${text.primary};
  font-size: 16px;
  line-height: 1;
  outline: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export default Footer;
